<template>
  <div>
    <iframe
      title=""
      v-if="iframeUrl"
      :src="iframeUrl"
      class="w-screen h-screen overflow-y-hidden"
      sandbox="allow-forms allow-scripts allow-modals allow-popups allow-same-origin allow-top-navigation"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import {onMounted, ref} from "vue";
import configFactory from "@/configFactory";
import {storeToRefs} from "pinia";
import {useCampaignStore} from "@/store/campaign";

export default {
  name: "CampaignLanding",

  created() {
    const slug = this.$route.params.pathMatch
    this.iframeUrl = this.urlMap[slug] || null;
    if(!this.iframeUrl) {
      this.$router.push({ path: '/home' })
    }
  },

  setup() {
    const newConfig = configFactory().getConfig();
    const {filename} = storeToRefs(useCampaignStore())
    const iframeUrl=ref()

    const urlMap = ref({
      'rabbits-hole-2025': `${newConfig.campaignUrl}/campaigns/promo/${filename.value}/index.html`,
      'rabbits-hole-2025/academy': `${newConfig.campaignUrl}/campaigns/promo/${filename.value}/academy.html`,
    })

    const messageIframe = ({data}) => {
      if (data.type === 'NAVIGATE') {
        window.location.href = data.url;
      }
    }

    onMounted(async () => {
      window.addEventListener('message', messageIframe);
    });

    return {urlMap,iframeUrl}
  }
};
</script>
